import * as React from 'react';

interface CustomBalanceOptionProps {
  isFirstOption,
  balance,
  freeBalance,
}

export const CustomBalanceOption = ({
  isFirstOption, balance, freeBalance,
}: CustomBalanceOptionProps) => {
  if (isFirstOption) {
    return (
      <>
        <span className="free-balance">{`$${freeBalance.toLocaleString()}`}</span>
        &nbsp;
        <span className="account-balance">(included with plan)</span>
      </>
    );
  }
  return (
    <>
      <span className="free-balance">{`$${(balance + freeBalance).toLocaleString()}`}</span>
      &nbsp;
      <span className="account-balance">Account Balance</span>
      &nbsp;
      <span className="additional-balance bright-green">{`(+$${balance.toLocaleString()})`}</span>
    </>
  );
};